/**
 * share-link.ts — Gửi một liên kết sang thiết bị khác (điện thoại → máy tính) cho chức năng chỉ dùng được trên máy tính.
 * Điện thoại có bảng chia sẻ của hệ điều hành (Zalo, Messenger, email, "gửi cho chính mình"…) → dùng nó; không có thì sao chép.
 */
import { i18n } from '@/lib/i18n'
export type ShareResult = 'shared' | 'copied' | 'cancelled' | 'failed'

export interface ShareNav {
  share?: (data: { title?: string; url?: string }) => Promise<void>
  clipboard?: { writeText: (text: string) => Promise<void> }
}

/** Đường dẫn trong ứng dụng → địa chỉ đầy đủ (mở được trên máy khác). */
export function absoluteUrl(path: string, origin: string): string {
  return new URL(path, origin).href
}

export async function shareLink(url: string, title: string, nav: ShareNav = navigator): Promise<ShareResult> {
  if (typeof nav.share === 'function') {
    try {
      await nav.share({ title, url })
      return 'shared'
    } catch (err) {
      // Người dùng đóng bảng chia sẻ → không phải lỗi, cũng không tự chép đè vào clipboard.
      if ((err as { name?: string })?.name === 'AbortError') return 'cancelled'
      // Lỗi khác (trình duyệt chặn) → thử sao chép.
    }
  }
  try {
    await nav.clipboard!.writeText(url)
    return 'copied'
  } catch {
    return 'failed'
  }
}

export const SHARE_TOAST: Record<ShareResult, { type: 'success' | 'error' | null; text: string }> = {
  shared: { type: 'success', get text() { return i18n.t('sharedMisc:shareLink.shared') } },
  copied: { type: 'success', get text() { return i18n.t('sharedMisc:shareLink.copied') } },
  cancelled: { type: null, text: '' },
  failed: { type: 'error', get text() { return i18n.t('sharedMisc:shareLink.failed') } },
}
